module.exports = __webpack_public_path__ + "static/media/velour13E.67d0bbcb.jpg";